export const COPY_CODE_SKELETON_COUNT = 3;